import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./AdressCard.styles";
import { Card, CardContent, WithStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography/Typography";

export interface IAddressProps extends WithStyles<typeof styles> {
    address: IAddress
    float?: boolean
    title: string
}

export interface IAddress {
    name: string,
    addressLine1: string,
    addressLine2: string,
    postcode: string,
    city: string,
    country: string
}

const AddressCardPure: React.FunctionComponent<IAddressProps> = ({
                                                                     address,
                                                                     float,
                                                                     title,
                                                                     classes
                                                                 }: IAddressProps) => {

    return <Card className={float ? classes.cardFloat : classes.card}>
        <CardContent>
            <Typography variant="h6" className={classes.cardTitle}>{title}</Typography>
            {(address.name && address.addressLine1 && address.city && address.postcode && address.country)
                ? <div>
                    <Typography variant="body2">{address.name}</Typography>
                    <Typography variant="body2">{address.addressLine1}</Typography>
                    <Typography variant="body2">{address.addressLine2}</Typography>
                    <Typography variant="body2">{address.postcode} {address.city}</Typography>
                    <Typography variant="body2">{address.country}</Typography>
                </div>
                : <div>
                    <Typography className={classes.addressError} variant="body2">Please fill the {title}</Typography>
                </div>
            }
        </CardContent>
    </Card>;
};

export const AddressCard = withStyles(styles)(AddressCardPure);
